namespace Nobox.Nobox {
    export interface TestMailObject {
        Host?: string;
        Port?: number;
        UseSSL?: number;
        Username?: string;
        Password?: string;
        IsSMTP?: number;
        Provider?: string;
        ApiKey?: string;
        Url?: string;
        Endpoint?: string;
        MailFrom?: string;
        MailTo?: string;
        IsError?: boolean;
        ErrMsg?: string;
    }
}
